<template>
  <div :class="{'card-form__container': true, 'card-form--collapsed': !collapsed}">
    <div v-if="collapsed">
      <slot name="expanded" />
    </div>
    <div v-else>
      <slot name="collapsed" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'CardForm',
  props: {
    collapsed: Boolean
  }
}
</script>

<style lang="scss">
  @import '../../../static/stylesheets/mixins';
  .card-form__container {
    padding: 22px 27px 20px;
    background-color: #fff;
    position: relative;

    .submit-button {
      height: 36px;
      width: 160px;
      position: absolute;
      bottom: 37px;
      right: 39px;
    }
  }
</style>
